import React from 'react';
import { useHistory } from 'react-router-dom';
import ConfirmDialog from './ConfirmDialog.jsx';
import { TITULO_SALIDA_CON_MARCAS } from '../domain/media.js';

const AdvertenciaSalida = ({ cuando, descripcion, confirmText = 'Salir sin eliminar' }) => {
  const history = useHistory();
  const [pendiente, setPendiente] = React.useState(null); // { location, action } de la navegación bloqueada
  const unblockRef = React.useRef(null);

  React.useEffect(() => {
    if (!cuando) return undefined;

    const unblock = history.block((location, action) => {
      setPendiente({ location, action });
      return false;
    });
    unblockRef.current = unblock;
    return () => {
      unblock();
      unblockRef.current = null;
      setPendiente(null);
    };
  }, [cuando, history]);

  const salir = () => {
    const destino = pendiente;
    setPendiente(null);
    if (!destino) return;
    if (unblockRef.current) unblockRef.current();
    unblockRef.current = null;
    if (destino.action === 'REPLACE') history.replace(destino.location);
    else history.push(destino.location);
  };

  return (
    <ConfirmDialog
      open={!!pendiente}
      variant="warning"
      title={TITULO_SALIDA_CON_MARCAS}
      description={descripcion}
      confirmText={confirmText}
      cancelText="Seguir editando"
      onConfirm={salir}
      onCancel={() => setPendiente(null)}
    />
  );
};

export default AdvertenciaSalida;
